type Ctor = typeof AudioContext;

let ctx: AudioContext | null = null;
let unlocked = false;

const getCtor = (): Ctor | null => {
  if (typeof window === 'undefined') return null;
  const w = window as Window & { webkitAudioContext?: Ctor };
  return window.AudioContext ?? w.webkitAudioContext ?? null;
};

export const getAudioContext = (): AudioContext | null => {
  if (ctx) return ctx;
  const Ctor = getCtor();
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
};

export const unlockAudio = (): void => {
  if (unlocked) return;
  const c = getAudioContext();
  if (!c) return;
  if (c.state === 'suspended') void c.resume();
  unlocked = true;
};

export const isAudioReady = (): boolean => {
  const c = getAudioContext();
  return !!c && c.state === 'running';
};
